var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,6.971v10.658c0,2.458-1.984,4.449-4.432,4.449h-10.617c-2.624,0-3.936-3.184-2.084-5.048l3.836-3.851c-2.452-2.02-5.52-3.148-8.789-3.148-7.673,0-13.917,6.269-13.917,13.971s6.245,13.967,13.917,13.967c4.6,0,8.905-2.281,11.501-6.104,1.248-1.831,3.736-2.301,5.565-1.052,1.824,1.253,2.292,3.751,1.048,5.582-4.092,6.016-10.865,9.606-18.11,9.606-12.085,0-21.918-9.871-21.918-21.998S11.829,2,23.914,2c5.432,0,10.497,1.976,14.457,5.489l2.6-2.61c1.856-1.863,5.028-.542,5.028,2.092Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.f7762964dcf367322a803e9a4a263574.svg";
export { ForwardRef as ReactComponent };